import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { computed, observable } from 'mobx';
import { Model } from 'libx';
import moment from 'moment';
import { omitUndefined } from 'utils/objectUtil';
import Amendment from './Amendment';
var JobEvent = (_class = /*#__PURE__*/function (_Model) {
  function JobEvent() {
    var _this;
    _classCallCheck(this, JobEvent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, JobEvent, [].concat(args));
    _initializerDefineProperty(_this, "previousProviderId", _descriptor, _this);
    _initializerDefineProperty(_this, "providerId", _descriptor2, _this);
    _initializerDefineProperty(_this, "newProviderId", _descriptor3, _this);
    _initializerDefineProperty(_this, "newClientId", _descriptor4, _this);
    _initializerDefineProperty(_this, "triggeredById", _descriptor5, _this);
    _initializerDefineProperty(_this, "jobId", _descriptor6, _this);
    _initializerDefineProperty(_this, "taskId", _descriptor7, _this);
    _initializerDefineProperty(_this, "taskTitle", _descriptor8, _this);
    return _this;
  }
  _inherits(JobEvent, _Model);
  return _createClass(JobEvent, [{
    key: "job",
    get: function get() {
      return this.rootStore.jobStore.jobs.get(this.jobId);
    }
  }, {
    key: "previousProvider",
    get: function get() {
      return this._refMember(this.previousProviderId);
    }
  }, {
    key: "provider",
    get: function get() {
      return this._refMember(this.providerId);
    }
  }, {
    key: "newProvider",
    get: function get() {
      return this._refMember(this.newProviderId);
    }
  }, {
    key: "newClient",
    get: function get() {
      return this._refMember(this.newClientId);
    }
  }, {
    key: "triggeredBy",
    get: function get() {
      return this._refMember(this.triggeredById);
    }
  }, {
    key: "eventCategory",
    get: function get() {
      switch (this.eventType) {
        case 'TASK_MARKED_COMPLETE':
        case 'TASK_MARKED_INCOMPLETE':
          return 'TASK_UPDATES';
        default:
          return 'JOB_UPDATES';
      }
    }

    /**
     * Convenience getter for all users on an event.
     */
  }, {
    key: "allMembers",
    get: function get() {
      return [this.previousProvider, this.provider, this.newProvider, this.newClient, this.triggeredBy].filter(function (x) {
        return x.workspaceId && x.userId;
      });
    }
  }, {
    key: "_refMember",
    value: function _refMember(userId) {
      if (!this.job) {
        return {};
      }
      return this.rootStore.memberStore.forWorkspaceAndUserId(this.job.workspaceId, userId) || {};
    }
  }, {
    key: "parse",
    value: function parse(json) {
      var previousProvider = json.previous_provider || {};
      var provider = json.provider || {};
      var newProvider = json.new_provider || {};
      var newClient = json.new_client || {};
      var triggeredBy = json.triggered_by || {};

      // Refresh all these users.
      var job = this.rootStore.jobStore.jobs.get(json.job_id);
      if (job) {
        this.rootStore.memberStore.setAndFetch([previousProvider, provider, newProvider, newClient, triggeredBy].filter(function (x) {
          return x.user_id;
        }).map(function (x) {
          return {
            workspace_id: job.workspaceId,
            user_id: x.user_id,
            user_public_id: x.user_public_id
          };
        }));
      }

      // JEFF SAID SO
      // if (json.snapshot && json.snapshot.date_modified) {
      //   // Update the in-memory job if we have one, but only if
      //   // the snapshot is newer than what we have.
      //   if (
      //     !job ||
      //     (job.dateModified &&
      //       moment(json.snapshot.date_modified).isAfter(job.dateModified))
      //   ) {
      //     // Snapshot is newer than what we have; set it.
      //     this.rootStore.jobStore.jobs.set(json.snapshot)
      //   }
      // }

      var workspaceId = json.workspace_id || job && job.workspaceId || json.snapshot && json.snapshot.workspace_id;
      return omitUndefined({
        id: json.id,
        dateCreated: moment(json.date_created),
        jobId: json.job_id,
        taskId: json.task_id,
        taskTitle: json.task_title || getTaskTitleFromSnapshot(json.snapshot, json.task_id),
        amendment: json.amendment ? new Amendment(_objectSpread(_objectSpread({}, json.amendment), {}, {
          workspace_id: workspaceId
        }), {
          parse: true,
          rootStore: this.rootStore,
          job: this.rootStore.jobStore.jobs.set({
            id: json.job_id,
            workspace_id: workspaceId
          })
        }) : null,
        reason: json.reason,
        description: json.description,
        dateTransmitted: json.date_transmitted ? moment(json.date_transmitted) : null,
        dateAccepted: json.date_accepted ? moment(json.date_accepted) : null,
        dateReopened: json.date_reopened ? moment(json.date_reopened) : null,
        dateClosed: json.date_closed ? moment(json.date_closed) : null,
        previousProviderId: previousProvider.user_id,
        providerId: provider.user_id,
        newProviderId: newProvider.user_id,
        newClientId: newClient.user_id,
        triggeredById: triggeredBy.user_id,
        eventVisibility: json.event_visibility,
        eventType: json.event_type,
        rebound: json.rebound
      });
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "previousProviderId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "providerId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "newProviderId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "newClientId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "triggeredById", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "taskId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "taskTitle", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "job", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "job"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "provider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "provider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "newProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "newClient", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "newClient"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triggeredBy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "triggeredBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eventCategory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eventCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allMembers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "allMembers"), _class.prototype), _class);
export { JobEvent as default };
/**
 * If the task_title is not present, get the task title from the snapshot.
 */
function getTaskTitleFromSnapshot() {
  var snapshot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var taskId = arguments.length > 1 ? arguments[1] : undefined;
  if (!taskId) {
    return '';
  }
  var milestone = (snapshot.milestones || []).find(function (m) {
    return getTask(m, taskId);
  });
  var task = getTask(milestone, taskId);
  return task ? task.title : taskId;
}

/**
 * Gets a task in a milestone.
 *
 * @param {*} milestone
 * @param {*} taskId
 */
function getTask(milestone, taskId) {
  return milestone.tasks.find(function (x) {
    return x.id === taskId;
  });
}
//# sourceMappingURL=JobEvent.js.map
